import { render } from "./UpdateFirmwareComponent.vue?vue&type=template&id=6f00a63c"
import script from "./UpdateFirmwareComponent.vue?vue&type=script&lang=js"
export * from "./UpdateFirmwareComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__